import { KuposCommonLoader, KuposErrorSuccessModal } from '../../common';
import React, { Component, useEffect, useState } from 'react';

import ApiUrls from '../../../services/apiUrls';
import BodyItem from './components/BodyItem';
import CommonService from '../../../services/commonService';
import DateService from '../../../services/dateService';
import KuposDataNotFound from '../../common/KuposDataNotFound';
import { KuposPoolModal } from '../../common/KuposPoolModal';
import TrainBodyItem from './components/TrainBodyItem';

function MainTabsBodyMyTrips(props) {
  const [subBodyItem, setSubBodyItem] = useState([
    {
      heading: 'Proximos viajes',
      title: 'Santiago vina del mar',
      description1: 'Miercolos, 11 de june de 2019',
      description2: 'Estatus: proximo',
      amount: 'CLP$500',
    },
    {
      heading: 'Viajes anteriories',
      title: 'Santiago valparasio',
      description1: 'Miercolos, 15 de mayo de 2019',
      description2: 'Estatus: Finalizado',
      amount: 'CLP$500',
    },
  ]);
  const [busTicketLoading, setBusTicketLoading] = useState(false);
  const [busTicketCancellationLoading, setBusTicketCancellationLoading] = useState(null);
  const [ticketDetailsBus, setTicketDetailsBus] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(null);
  const [modalSuccess, setModalSuccess] = useState(null);
  const [modalBodyText, setModalBodyText] = useState(null);
  const [showPoolModal, setShowPoolModal] = useState(null);
  const [selectedTripItem, setSelectedTripItem] = useState(null);

  // COMPONENT DID MOUNT
  useEffect(() => {
    getBusTrips();
  }, []);

  const getBusTrips = () => {
    const { getMyTripsBus } = props.actions;
    getMyTripsBus({ url: ApiUrls.myTrips() });
  };

  const notIspast = (date) => {
    if (date < DateService.getTodayString('yyyy-mm-dd')) {
      return false;
    }
    return true;
  };

  const onSeeMoreClickedBus = (val, i) => {
    setSelectedTripItem(i);

    props.actions.loadTicketDetails({ url: ApiUrls.ticketDetails(val.pnr_number) }).then(
      (res) => {
        if (res.body && res.body.pnr_number) {
          setTicketDetailsBus(res.body);
          setBusTicketLoading(false);
        } else {
          setBusTicketLoading(false);
        }
      },
      (err) => {
        setBusTicketLoading(false);
      },
    );
  };

  const cancelBusTicket = (ticketDetails, type) => {
    props.actions.setTicketDetails(ticketDetails);
    if (type == 'bus') {
      sessionStorage.setItem('is_change_ticket', false);
      props.history.push('/modify-ticket/cancel');
    } else if (type == 'at') {
      let timeNow = DateService.getTimeInSeconds(new Date());
      let path = `api/v1/cancelSearch/${ticketDetails.customer_email}/${ticketDetails.trip_ref_date}/${ticketDetails.pnr_id}/${timeNow}`;
      props.actions.loadTicketDetails({ url: ApiUrls.ticketCancelDetailsAT(path) }).then(
        (res) => {
          // props.actions.setTicketDetails(res);
          if (res.data && res.data) {
            setBusTicketCancellationLoading(false);

            if (res.success && res.data && res.data.can_be_cancelled) {
              sessionStorage.setItem(
                'ticketInfo',
                JSON.stringify({
                  ticketDetails: res.data,
                  metaData: props.home ? props.home.metaData : null,
                }),
              );
              props.history.push('/at-modify-ticket/cancel');
            }
          } else {
            CommonService.removeLocal('ticketInfo');

            setShowSuccessModal(true);
            setModalSuccess(false);
            setModalBodyText(res.body.message);
            setBusTicketCancellationLoading(false);
          }
        },
        (err) => {
          setBusTicketCancellationLoading(false);
          setShowSuccessModal(true);
          setModalSuccess(false);
          setModalBodyText(
            'No tenemos resultados con los datos compartidos. Por favor revisa tu información e intenta nuevamente.',
          );
        },
      );
    }
  };

  const renderNoTripsFound = (icon, onPress, i, modal = false) => {
    return (
      <KuposDataNotFound
        icon={icon}
        title={props.t('PROFILE.DONT_HAVE_ANY_TRIPS')}
        subTitle={props.t('PROFILE.PLAN_NEW_TRIP')}
        infoText={props.t('PROFILE.SEARCH_BUS_HERE')}
        onInfoClick={() => {
          modal ? setShowPoolModal(modal) : props.history.push(onPress);
          props.actions.setSearchApp(i);
          window.scrollTo(0, 0);
        }}
      />
    );
  };

  const { t } = props;
  return (
    <div className="sub-section-description scroll-style my-trips">
      <div className="my-trips-body">
        <BodyItem
          type="bus"
          onSeeMoreClickedBus={onSeeMoreClickedBus}
          renderNoTripsFound={renderNoTripsFound}
          t={props.t}
          busTicketLoading={busTicketLoading}
          ticketDetailsBus={ticketDetailsBus}
          selectedTripItem={selectedTripItem}
          // renderKuposGoBodyItem={renderKuposGoBodyItem}
          notIspast={notIspast}
          cancelBusTicket={cancelBusTicket}
          busTicketCancellationLoading={busTicketCancellationLoading}
          data={props.data}
        />
      </div>

      <KuposErrorSuccessModal
        showModal={showSuccessModal}
        success={modalSuccess}
        onButtonClick={() => {
          setShowSuccessModal(false);
          setModalBodyText('');
        }}
        bodyText={modalBodyText}
      />

      <KuposPoolModal
        showModal={showPoolModal}
        onHide={() => setShowPoolModal(false)}
        image={t('HOME.KUPOS_POOL_IMAGE')}
        metaData={props.metaData}
        t={props.t}
        googlePlay={t('HOME.GOOGLE_PLAY_DARK')}
        appStore={t('HOME.APP_STORE_DARK')}
      />
    </div>
  );
}

export default MainTabsBodyMyTrips;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyTrips/MainTabsBodyMyTrips.js